import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface SedanDefaultIconProps {
  color?: Color;
}

const SedanDefaultIcon: React.FC<SedanDefaultIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.77 21.3C10.09 21.3 8.60995 21.38 8.11995 21.45C7.62995 21.52 6.45003 21.83 6.32003 22.17C6.19003 22.51 5.54004 23.29 5.71004 23.42C6.7865 23.5079 7.86924 23.4811 8.94002 23.34C9.66926 22.7436 10.3605 22.1024 11.01 21.42C11.06 21.36 10.99 21.29 10.77 21.3Z"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M25.3101 18.48C25.3101 18.48 37.1401 17.9 41.8401 17.81L62.8401 17.44"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path d="M42.91 13.43L41.83 17.81" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
    <path d="M54.04 13.76L56.09 17.53" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
    <path
      d="M65.98 28.94C66.83 28.85 70.26 28.54 71.98 28.16C73.28 27.88 73.37 24.51 73.37 24.51L72.48 22.6C72.48 22.6 72.48 21.75 72.38 20.68C72.5003 20.0803 72.4856 19.4613 72.3368 18.868C72.1881 18.2747 71.909 17.722 71.52 17.25C71.12 17.01 64.4201 16.14 64.4201 16.14C64.4201 16.14 61.78 14.91 59.9 14.14C57.4932 13.1416 55.0038 12.3553 52.4601 11.79C39.5701 10.79 34.7401 12.05 33.3101 12.51C29.9267 14.0138 26.6403 15.7271 23.4701 17.64C19.3401 17.53 11.4101 18.96 9.69008 19.42C7.88387 19.8737 6.18481 20.6791 4.69008 21.79C3.31008 22.88 3.19004 25.96 3.40004 27.68C3.61004 29.4 4.83007 29.48 5.55007 29.59C6.27007 29.7 9.65004 30 9.65004 30"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path d="M23.59 29.72H51.59" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
    <path
      d="M72.2499 18.83H68.84C68.803 18.8274 68.766 18.8358 68.7337 18.854C68.7014 18.8722 68.6752 18.8994 68.6582 18.9324C68.6411 18.9653 68.6341 19.0026 68.638 19.0395C68.6419 19.0763 68.6565 19.1113 68.68 19.14C68.8708 19.4276 69.0813 19.7016 69.31 19.96C69.56 20.22 69.9599 20.77 70.4799 20.8C70.9999 20.83 72.41 20.8 72.41 20.8"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M63.9301 27.29C63.9301 27.36 63.9301 27.44 63.9301 27.52C63.9301 28.1893 63.798 28.852 63.5416 29.4702C63.2852 30.0884 62.9094 30.6499 62.4357 31.1227C61.962 31.5955 61.3997 31.9702 60.781 32.2254C60.1623 32.4806 59.4993 32.6113 58.8301 32.61C57.4801 32.61 56.1854 32.0737 55.2308 31.1192C54.2763 30.1646 53.74 28.8699 53.74 27.52C53.7532 26.177 54.2967 24.8936 55.252 23.9496C56.2072 23.0055 57.497 22.4773 58.8401 22.48C60.003 22.4791 61.1315 22.8741 62.04 23.6"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M21.3401 27.38C21.3451 27.4599 21.3451 27.5401 21.3401 27.62C21.3401 28.2884 21.2084 28.9503 20.9526 29.5679C20.6968 30.1854 20.3219 30.7465 19.8492 31.2192C19.3766 31.6918 18.8154 32.0668 18.1979 32.3226C17.5803 32.5784 16.9184 32.71 16.25 32.71C15.5807 32.7113 14.9178 32.5806 14.2991 32.3254C13.6804 32.0702 13.1181 31.6955 12.6444 31.2227C12.1707 30.75 11.7949 30.1884 11.5385 29.5702C11.282 28.952 11.15 28.2893 11.15 27.62C11.15 26.2674 11.6874 24.9702 12.6438 24.0138C13.6002 23.0573 14.8974 22.52 16.25 22.52C17.4112 22.521 18.5371 22.9198 19.4401 23.65"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
  </svg>
);

export default SedanDefaultIcon;
